import { render, staticRenderFns } from "./OnBoarded.vue?vue&type=template&id=27034176&scoped=true"
import script from "./OnBoarded.vue?vue&type=script&lang=js"
export * from "./OnBoarded.vue?vue&type=script&lang=js"
import style0 from "./OnBoarded.vue?vue&type=style&index=0&id=27034176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27034176",
  null
  
)

export default component.exports